module.exports = __webpack_public_path__ + "img/play.70ba32f7.svg";